import script from "./ScoreAchievement.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreAchievement.vue?vue&type=script&setup=true&lang=js"

import "./ScoreAchievement.vue?vue&type=style&index=0&id=27d82cee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d82cee"]])

export default __exports__